import { WaitingGuestsPageContent } from "@/components/waitingGuests/WaitingGuestsPageContent";

const WaitingGuests = () => {
  return <WaitingGuestsPageContent />;
};

export default WaitingGuests;
